export default "__VITE_ASSET__m9opTBgKRGAYPBi8GR2SNA__"